<template lang="pug">
  div(@click.stop="onDoodleWrapper"
    :class="{'active': active}"
    :style="`transform: scale(${scaleByScore});`").wrap-item-doodle-wrapper.cursor-pointer
    transition(name="actions")
      div(v-if="active" :style="`transform: scale(${wrapActionScale});`").wrap-actions.f.fm.flex-between.py4
        div.wrap-delete.mr12
          span(@click="onDelete" v-if="doodle.createdBy === uid || hostUid === uid").fz12.cursor-pointer Delete          
        div.f.fm
          div(@click.stop="onLike"
            :class="{'added': doodle.likedBy.includes(uid)}").f.fm.mr8
            v-icon(size="20px"
              :color="(doodle.likedBy.includes(uid)) ? pallete.$active_color : pallete.$secondary_text_color"
              ).mr4 {{(doodle.likedBy.includes(uid)) ? 'mdi-thumb-up' : 'mdi-thumb-up'}}
            span.num-text.fz16.block {{doodle.likeNum}}
          div(@click.stop="onDislike"
            :class="{'added': doodle.dislikedBy.includes(uid)}").f.fm
            v-icon(size="20px"
              :color="(doodle.dislikedBy.includes(uid)) ? pallete.$active_color : pallete.$secondary_text_color"
              ).mr4 {{(doodle.dislikedBy.includes(uid)) ? 'mdi-thumb-down' : 'mdi-thumb-down'}}
            span.num-text.fz16.block {{doodle.dislikeNum}}
    transition(name="doodle")
      div(v-if="showContent" :class="{'animation-bound': activeBoundClass}").doodle-content
        div(:class="animationClassName")
          slot
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/doodleAnimation.scss";

.wrap-item-doodle-wrapper {
  position: relative;
  transition: transform 400ms $ease_out_expo;
  .wrap-actions {
    position: absolute;
    width: 100%;
    right: 0;
    bottom: 100%;
    .wrap-delete {
      color: $dangerous_color;
    }
    .num-text {
      color: $secondary_text_color;
    }
    .added {
      .num-text {
        color: $active_color;
      }
    }
  }
  &.active {
    z-index: 110;
    .doodle-content {
      // filter: drop-shadow(0px 1px 5px $active_color);
      filter: drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.3));
    }
  }
  .doodle-content {
    &.animation-bound {
      animation-name: doodle-rotate;
      animation-duration: 200ms;
    }
    @keyframes doodle-rotate {
      0% {
        transform: rotateZ(0deg);
      }
      25% {
        transform: rotateZ(-10deg);
      }
      50% {
        transform: rotateZ(0deg);
      }
      75% {
        transform: rotateZ(10deg);
      }
      100% {
        transform: rotateZ(0deg);
      }
    }
  }
}

.doodle-leave-active, .doodle-enter-active {
  transition: all 0.4s $ease_out_elastic;
}
.doodle-enter, .doodle-leave-to {
  opacity: 0;
  transform: scale(0.2);
}
.doodle-enter-to, .doodle-leave {
  opacity: 1;
  transform: scale(1.0);
}

.actions-leave-active, .actions-enter-active {
  transition: all 0.6s $ease_out_expo;
}
.actions-enter, .actions-leave-to {
  opacity: 0;
  transform: translateY(10%);
}
.actions-enter-to, .actions-leave {
  opacity: 1;
  transform: translateY(0%);
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    doodle: {
      type: Object,
      required: true
    },
    hostUid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      active: false,
      isSaving: false,
      showContent: false,
      activeTimer: null,
      activeBoundClass: false,
      activeBoundClassTimer: null
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    scaleByScore () {
      if (this.doodle.likeNum + this.doodle.dislikeNum === 0) return 1.0

      let result
      // if (this.doodle.likeNum === 0) {
      //   result = this.doodle.dislikeNum < 10 ?
      //     1 - this.doodle.dislikeNum / 10 * 0.1 : 0
      //   return result
      // }
      // if (this.doodle.dislikeNum === 0) {
      //   result = this.doodle.likeNum < 10 ?
      //     1 + this.doodle.likeNum / 10 * 0.1 : 0
      //   return result
      // }
      
      const score = (this.doodle.likeNum - this.doodle.dislikeNum) / (this.doodle.likeNum + this.doodle.dislikeNum)

      // Good10個分、Bad10個分まではadditioal scoreとして反映
      const additioalLikeScore = this.doodle.likeNum <= 10 ?
        this.doodle.likeNum : 10
      const additioalDislikeScore = this.doodle.likeNum <= 10 ?
        this.doodle.dislikeNum : 10
      const additioalScore = (additioalLikeScore - additioalDislikeScore) * 0.01

      result = 1 + score * 0.5 + additioalScore
      return (result > 0.0) ? result :  0.0
    },
    wrapActionScale () {
      // 小さくなりすぎてボタンが押せないようにならないようにする
      const scale = 1.0 + (1 - this.scaleByScore)
      return (this.scaleByScore >= 1.0) ? 1.0 : scale * scale
    },
    animationClassName () {
      return this.doodle.animation ? `doodle-animation-${this.doodle.animation}` : ''
    }
  },
  watch: {
    // doodle (newDoodle, oldDoodle) {
    //   console.log('new', newDoodle)
    //   console.log('old', oldDoodle)
    //   if (!oldDoodle) {
    //     this.showContent = true
    //     this.active = true
    //     this.activeTimer = setTimeout(() => {
    //       this.active = false
    //     }, 4000)
    //   }
    // }
    scaleByScore () {
      clearTimeout(this.activeBoundClassTimer)
      this.activeBoundClassTimer = setTimeout(() => {
        this.activeBoundClass = false
      }, 400)
      this.activeBoundClass = true

      this.activeTimer = setTimeout(() => {
        this.active = false
      }, 4000)
      this.active = true
    }
  },
  created () {
    const dateGap = new Date() - this.doodle.createdAt.toDate()
    if (dateGap < 10000) {
      this.showContent = false
    } else {
      this.showContent = true
    }
  },
  async mounted () {
    window.addEventListener('click', this.close)
    
    const dateGap = new Date() - this.doodle.createdAt.toDate()
    if (dateGap < 10000) {
      this.showContent = true
      this.$emit('playDoodleSound', {
        id: 'doodle_created',
        volume: 0.5
      })
      this.activeTimer = setTimeout(() => {
        this.active = false
      }, 4000)
      await this.sleep(1000)
      this.active = true
    }
  },
  beforeDestroy() {
    window.removeEventListener('click', this.close)
  },
  methods: {
    onDoodleWrapper () {
      this.active = !this.active
      clearTimeout(this.activeTimer)
    },
    close () {
      this.active = false
    },
    async onDelete () {
      const go = confirm('Really?')
      if (!go) return
      await database.slideCollection()
        .deleteDoodle(this.$route.params.slideId, this.doodle.id)
    },
    async onLike () {
      // console.log('onLike:')
      if (this.isSaving || this.doodle.likedBy.includes(this.uid)) return
      this.isSaving = true

      const like = {
        slide: this.$route.params.slideId,
        page: this.doodle.page,
        doodle: this.doodle.id,
        createdBy: this.uid,
        createdAt: new Date()
      }
      await database.slideCollection()
        .addLike(this.$route.params.slideId, this.doodle.id, like)

      this.isSaving = false
    },
    async onDislike () {
      // console.log('onDislike:')
      if (this.isSaving || this.doodle.dislikedBy.includes(this.uid)) return
      this.isSaving = true

      const dislike = {
        slide: this.$route.params.slideId,
        page: this.doodle.page,
        doodle: this.doodle.id,
        createdBy: this.uid,
        createdAt: new Date()
      }
      await database.slideCollection()
        .addDislike(this.$route.params.slideId, this.doodle.id, dislike)

      this.isSaving = false
    }
  }
}
</script>
